import {GET_PROJECTS, GET_PROJECTS_ERROR} from '../types'
import axios from 'axios'
import { ROUTE, PATH } from "../constants";
import { is_login } from './is_login';


export const getProjectsActions = (token) => async dispatch => {
    
    try{
        const config = {
            headers: { Authorization: `Bearer ${token}` }
        };

        const API = `${process.env.REACT_APP_SERVER_HOST}${PATH}${is_login()?ROUTE.PROJECTS:ROUTE.PROJECTS_BEFORE_LOGIN}`;
        const res = await axios.get(API,config);
        dispatch( {
            type: GET_PROJECTS,
            payload: res.data
        })
    }
    catch(error){
        console.log(error);
        dispatch( {
            type: GET_PROJECTS_ERROR,
            payload: error,
        })
    }

}

